import { defineComponent as _defineComponent } from 'vue'
import TextField from '@/components/BlockEditor/ButtonEditorDrawer/TextField.vue';
import PrimaryButton from '@/components/atoms/buttons/PrimaryButton.vue';
import { ref, computed, watch } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'DesignTileMenu',
  props: {
    title: null,
    isNew: { type: Boolean },
    loading: { type: Boolean }
  },
  emits: ["save", "update:tile-name", "open-builder"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'save', tileName: string, workflowTitle: string | null): void;
	(e: 'update:tile-name', value: string): void;
	(e: 'open-builder'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { title: string; isNew: boolean; loading: boolean }



const tileName = ref(props.title);
watch(
	() => tileName.value,
	() => {
		emit('update:tile-name', tileName.value);
	}
);
const _workflowTitle = ref('');
const workflowTitle = computed({
	get: () => (applyTooltipOnTitle.value ? tileName.value : _workflowTitle.value),
	set: (val) => (_workflowTitle.value = val),
});
const applyTooltipOnTitle = ref(true);
const setFeatureNameSeparately = () => {
	applyTooltipOnTitle.value = false;
	workflowTitle.value = tileName.value;
};
const onSave = () => {
	emit('save', tileName.value, props.isNew ? workflowTitle.value : null);
	props.isNew && emit('open-builder');
};

return { __sfc: true,props, emit, tileName, _workflowTitle, workflowTitle, applyTooltipOnTitle, setFeatureNameSeparately, onSave, TextField, PrimaryButton }
}

})